import React from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import CookieBanner from "@/components/layout/CookieBanner";
import { Toaster } from "@/components/ui/sonner";

export default function SiteLayout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-white">
            <Navbar />
            <main className="flex-1 pt-40">{children}</main>
            <Footer />
            <CookieBanner />
            <Toaster position="bottom-right" richColors />
        </div>
    );
}
